// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".countdown-timer p[data-v-759a6408]{color:inherit}.small-separator[data-v-759a6408]{padding:0 1px}", ""]);
// Exports
module.exports = exports;
